const utils = require('frontend-controller/lib/utils');
const store = require('frontend-controller/lib/store');

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		checkForBrowserFills: true,
		isLoginDialog: false,
		resetDirtyFieldsAfterSuccessfulSubmit: false,
		onSubmitDonePanelMessage: '',
		statusControllerLoadingMessage: '',
		statusControllerSavingMessage:  'status.progress.login',
		submitEventDefaultsGranted: true,
		preventIDSelector: true,

		resourceUrl: '/login',

		// credentialOptions: { // overrule some options used by credentialsManager.
		// 	forwardUrlScope: 'default', // overrule used forwardUrlScope.
		// }
	},

	methods: {

		/**
		 * this function is used to handle the different kinds of errors.
		 * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
		 * NOTE: if this function resolves the given context is always the original context and NOT the error handling context.
		 *
		 * @param   context             {} - action perform context
		 *          {
	     *              component: ...
	     *              [action]: ...
	     *              error: {
	     *                  statusCode: <statusCode>            mixed - status code || 'clientError'
	     *                  name: <statusCode>                  string - error name
	     *                  errorCode: <statusCode>             string - error code
	     *                  message: <statusCode>               string - error message
	     *                  details: <statusCode>               string - error details
	     *                  [childErrors]: []                   [] - list of child errors
	     *              },
	     *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
		 *                                      int - this error handling type defines the state of error handling
	     *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
	     *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
	     *          }
		 * @returns Promise
		 */
		handleError: function(context){
			var baseError = utils.extractBaseError(context.error);

			if(baseError.statusCode == 403){
				if(
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_1'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_2'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_3'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_4'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_LOGIN_ERROR_5'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_1'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_PIN_LOGIN_ERROR_2'
					||
					baseError.errorCode === 'LOCAL_USERMANAGEMENT_PROVIDER_LOGIN_ERROR'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_SCOPEROLE_PREPARE_ERROR_1'
					||
					baseError.errorCode === 'USERMANAGEMENT_PROVIDER_MANDATORY_SCOPE_MISSING_ERROR_1'
					||
					baseError.errorCode === 'SHADOW_COMPONENT_NOT_GRANTED'
				){
					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:login.invalidUserData'
							}
						}, {
							rollbackContext: context,
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					);
				}
			}
			else if(baseError.statusCode == 400){
				if(baseError.errorCode === 'USERMANAGEMENT_LOGIN_PARAMETER_ERROR'){
					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:login.inCompleteUserData'
							}
						}, {
							rollbackContext: context,
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					);
				}
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		/**
		 * this function will be called after the response of a submit request has returned.
		 *
		 * @param   response        {} - server response
		 */
		onSubmit: function(response){
			store.set(response);

			if(this.config.isLoginDialog){
				var storage = store.get();
				if(storage.user.data.states.authenticated){
					this.reperformRegisteredActions('relogin')
						.always(() => {
							storage.componentTree.callHandler(this, 'onSuccessfulLoginDialog');
						})
				}
			}
			else {
				window.location.href = window.location.href;
			}
		},

		onAttachDone(attachTriggerOptions){
			if(!attachTriggerOptions.refresh){
				let activationData = false
				this.locate('< templates_core_login_container > templates_core_login_activationDataHandler', activationDataHandler => {
					activationData = activationDataHandler.model.activationData
				})

				let refresh = false

				const userAttributes 	= (activationData || {}).userAttributes || {}
				const operations 		= (activationData || {}).operations || {}
				if(operations.autoFillLoginForm){
					if(userAttributes.code) 	this.fieldToModel('username', userAttributes.code);
					if(userAttributes.password) this.fieldToModel('password', userAttributes.password);
					refresh = true
				}

				if(utils.collectionSize(this.config.credentialOptions) > 0 && this.model.namedFields.credentialOptions){
					this.fieldToModel('credentialOptions', this.config.credentialOptions);
				}

				if(refresh){
					this.refresh(false)
				}
			}
		},
	},

	hooks: {
		onDecision: function($element, options){
			var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
			if(modalContentComponent.hasClass('templates_core_login_container')){
				this.submit();
			}
		}
	},

	handlers: [
		{
			name: 'onSuccessfulLoginDialog',
			handle: function(callerComponent){
				this.triggerClosest('onDecision', {
					decisionComponent: this,
					decisionType: 'cancel'
				});
			}
		}
	]
};
